import { render, staticRenderFns } from "./SubTopicDetails.vue?vue&type=template&id=29451d66&scoped=true&"
import script from "./SubTopicDetails.vue?vue&type=script&lang=js&"
export * from "./SubTopicDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubTopicDetails.vue?vue&type=style&index=0&id=29451d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29451d66",
  null
  
)

export default component.exports